import { render } from "./carousel-slide.vue?vue&type=template&id=82c33d44"
import script from "./carousel-slide.vue?vue&type=script&lang=js"
export * from "./carousel-slide.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__